import { componentName, ButtonMultiSelectionGroupClass } from './ButtonMultiSelectionGroupClass';
import '../descope-button-multi-selection-group-internal';
import '../descope-button-selection-group-item';

customElements.define(componentName, ButtonMultiSelectionGroupClass);

export { ButtonMultiSelectionGroupClass, componentName };
